module.exports = __webpack_public_path__ + "img/T2A_rc_7.b2562ba1.png";